module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "content"
  }, [_h('div', {
    directives: [{
      name: "show",
      value: (drap),
      expression: "drap"
    }],
    staticClass: "body-bg",
    on: {
      "click": function($event) {
        drap = !drap
      }
    }
  }), " ", _h('div', {
    staticClass: "b-page-header"
  }, [_h('topNav', {
    attrs: {
      "bg": navs.pic,
      "light": navs.style
    }
  }), " ", _h('bgNav', {
    attrs: {
      "logo": navs.litpic,
      "bg": navs.pic,
      "title": navs.name,
      "url": navs.url
    }
  })]), " ", " ", _h('SliderNav', {
    attrs: {
      "lists": clists,
      "left": slideLeft,
      "offsetTop": offsetTop,
      "drap": drap
    },
    on: {
      "updateDrap": updateDrap
    }
  }), " ", _h('div', {
    staticClass: "b-page-body"
  }, [_h('div', {
    ref: "container",
    staticClass: "container",
    attrs: {
      "id": "index-top"
    }
  }, [_h('div', {
    staticClass: "b-l"
  }, [_h('Mcarousel', {
    attrs: {
      "carousels": carousels
    }
  })]), " ", _h('div', {
    staticClass: "b-r"
  }, [_h('Lcarousel')])]), " ", " ", _h('section', {
    ref: "navDetail"
  }, [_l((clists), function(item) {
    return _h('div', {
      staticClass: "container b-section",
      attrs: {
        "id": item.id
      }
    }, [_h('p', [_s(item.name)])])
  })]), " ", _m(0)])])
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "footer container"
  }, [_h('a', {
    attrs: {
      "href": "https://github.com/xyxiao001",
      "target": "_blank"
    }
  }, ["footer"]), " ", _h('a', {
    attrs: {
      "href": "https://github.com/xyxiao001",
      "target": "_blank"
    }
  }, ["goodboy"]), " ", _h('p', ["看看超过会怎样"])])
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-loader/9.5.1/vue-loader/lib/template-compiler.js?id=data-v-1!./~/.npminstall/vue-loader/9.5.1/vue-loader/lib/selector.js?type=template&index=0!./src/view/Dashboard.vue
 ** module id = 32
 ** module chunks = 2
 **/